import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { ConfigLayerModule } from '@ddt-web/config-layer';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { TourBannerComponent, TourDialogComponent } from './components';
import { TourDialogService } from './services';

@NgModule({
	declarations: [TourDialogComponent, TourBannerComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		ConfigLayerModule,
		SharedModule,
		DzButtonModule,
		DzIconModule.withIcons(faTimes)
	],
	providers: [TourDialogService],
	exports: [TourBannerComponent]
})
export class NewFeatureTourModule { }
